// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Dq-z","breadcrumbForward":"Eq-z","breadcrumbBack":"Fq-z","selected":"Gq-z"};